// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8Z',
  'M6.7 6H9.3C9.69 6 10 6.31 10 6.7V9.3C10 9.69 9.69 10 9.3 10H6.7C6.31 10 6 9.69 6 9.3V6.7C6 6.31 6.31 6 6.7 6Z',
];
